{
  "features_page": {
    "title": "Explore features",
    "subtitle": "Discover everything your B2B store can do. Browse by category and expand any feature to learn more.",
    "no_billing_alert": {
      "title": "No billing plan selected",
      "message": "You currently have no active billing plan selected, so only features available on the basic plan are shown. If this issue persists, or this isn't what you expected to see, please get in touch with our team."
    },
    "plan_badge": "{plan} plan",
    "cta": {
      "read_the_docs": "Read the docs",
      "hide_suggestion": "Hide suggestion"
    },
    "empty_state": {
      "title": "You've explored all features in this category",
      "subtitle": "Visit the SparkLayer docs to discover more ways to get the most from your B2B store.",
      "docs_link": "Go to SparkLayer docs"
    },
    "ai_assistant": {
      "title": "Curious what SparkLayer can do?",
      "subtitle": "Ask our AI assistant and get instant answers about SparkLayer.",
      "cta": "Ask our AI assistant"
    },
    "examples": {
      "automatic": {
        "title": "Automatic pricing",
        "subtitle": "e.g. 50% of my store's retail prices"
      },
      "manual": {
        "title": "Manual pricing",
        "subtitle": "e.g. CSV upload of specific pricing per SKU"
      },
      "api": {
        "title": "API-powered pricing",
        "subtitle": "e.g. sync my Netsuite ERP pricing"
      },
      "promotional": {
        "title": "Promotional discounts",
        "subtitle": "e.g. set up coupons or automatic discounts for qualifying orders"
      },
      "product-detail": {
        "title": "Product page widgets",
        "subtitle": "e.g. show B2B pricing and add to order"
      },
      "product-cards": {
        "title": "Collection card widgets",
        "subtitle": "e.g. customers can build their orders from your collection pages"
      },
      "cart": {
        "title": "My cart interface",
        "subtitle": "e.g. a fast multi-line ordering cart"
      },
      "account": {
        "title": "My account interface",
        "subtitle": "e.g. orders, shopping lists and reordering"
      },
      "assigned-customer-specific": {
        "title": "Customer-specific pricing",
        "subtitle": "e.g. a tailored price list for one group or customer"
      },
      "assigned-collection": {
        "title": "Collection-based pricing",
        "subtitle": "e.g. upload pricing for a whole collection"
      },
      "order-rules-value": {
        "title": "Order value limits",
        "subtitle": "e.g. a $250 minimum spend per order"
      },
      "order-rules-quantity": {
        "title": "Order quantity limits",
        "subtitle": "e.g. require 10 units to place an order"
      },
      "stock-per-group": {
        "title": "Per customer group",
        "subtitle": "e.g. show stock to one group, hide it from another"
      },
      "stock-preorder": {
        "title": "Pre-order products",
        "subtitle": "e.g. hide stock levels on pre-order items"
      },
      "payment-upfront": {
        "title": "Upfront payment",
        "subtitle": "e.g. pay by card at checkout"
      },
      "payment-invoice": {
        "title": "Payment by invoice",
        "subtitle": "e.g. order now, pay against an invoice"
      },
      "payment-account": {
        "title": "Pay on account",
        "subtitle": "e.g. net terms or account payments"
      },
      "payment-quote": {
        "title": "Request a quote",
        "subtitle": "e.g. negotiate pricing and quantities first"
      },
      "catalog-visibility": {
        "title": "Hide products",
        "subtitle": "e.g. keep retail-only products out of trade orders, and vice versa"
      },
      "catalog-exclusive": {
        "title": "Trade-only ranges",
        "subtitle": "e.g. surface a wholesale-exclusive collection"
      },
      "catalog-per-group": {
        "title": "Per customer group",
        "subtitle": "e.g. a tailored assortment by tag or type"
      },
      "catalog-variants": {
        "title": "Variant-level control",
        "subtitle": "e.g. show only bulk case variants"
      },
      "forms-application": {
        "title": "Application form",
        "subtitle": "e.g. capture customer applications with business details, including VAT numbers and company information"
      },
      "forms-approval": {
        "title": "Approval workflow",
        "subtitle": "e.g. review applicants before approving B2B Access to your store"
      },
      "agents-ordering": {
        "title": "Order on behalf",
        "subtitle": "e.g. empower sales teams to place and manage orders for customers they support"
      },
      "agents-roles": {
        "title": "Roles & permissions",
        "subtitle": "e.g. create custom roles with the right level of access for every team member"
      },
      "terms-net": {
        "title": "Net terms",
        "subtitle": "e.g. Support net payment terms for approved customers or account-based purchasing with credit agreements"
      },
      "terms-credit": {
        "title": "Credit limits",
        "subtitle": "e.g. block checkout over a set limit"
      },
      "rules-pack-size": {
        "title": "Pack sizes",
        "subtitle": "e.g. sell specific products in packs of 12"
      },
      "rules-moq": {
        "title": "Minimum quantities",
        "subtitle": "e.g. a 24-unit minimum per order"
      },
      "rules-max-qty": {
        "title": "Maximum quantities",
        "subtitle": "e.g. a 50-unit maximum per order"
      },
      "rules-price-breaks": {
        "title": "Price breaks",
        "subtitle": "e.g. cheaper per unit over 50"
      },
      "discounts-order": {
        "title": "Order discounts",
        "subtitle": "e.g. 10% off orders over $1,000"
      },
      "discounts-codes": {
        "title": "Promo codes",
        "subtitle": "e.g. SAVE10 at checkout"
      },
      "discounts-group": {
        "title": "Customer offers",
        "subtitle": "e.g. a deal for one customer group"
      },
      "discounts-limits": {
        "title": "Usage limits",
        "subtitle": "e.g. start/end dates and usage caps"
      },
      "shipping-zones": {
        "title": "Rates by zone",
        "subtitle": "e.g. different rates per region"
      },
      "shipping-weight": {
        "title": "Weight & value rates",
        "subtitle": "e.g. price by order weight or total"
      },
      "shipping-group": {
        "title": "Per customer group",
        "subtitle": "e.g. free freight for key accounts"
      },
      "shipping-free": {
        "title": "Free-shipping thresholds",
        "subtitle": "e.g. free shipping over $500"
      },
      "invoicing-branded": {
        "title": "Branded invoices",
        "subtitle": "e.g. customers view and download a PDF"
      },
      "invoicing-drafts": {
        "title": "Draft orders",
        "subtitle": "e.g. auto-create draft orders in your store"
      },
      "accounting-invoices": {
        "title": "Sync invoices",
        "subtitle": "e.g. push invoices into Xero"
      },
      "accounting-payments": {
        "title": "Sync payments",
        "subtitle": "e.g. reconcile payments automatically"
      },
      "quoting-request": {
        "title": "Request a quote",
        "subtitle": "e.g. customers ask instead of buying"
      },
      "quoting-approve": {
        "title": "Review & approve",
        "subtitle": "e.g. adjust pricing, then convert to order"
      },
      "company-buyers": {
        "title": "Multiple buyers",
        "subtitle": "e.g. each teammate gets their own login"
      },
      "company-approval": {
        "title": "Approval permissions",
        "subtitle": "e.g. some users need sign-off to order"
      }
    },
    "categories": {
      "basics": {
        "name": "Basics",
        "description": "The essentials of SparkLayer - available to every store."
      },
      "advanced": {
        "name": "Advanced",
        "description": "Tailor how your customers buy, pay and are managed as you scale."
      },
      "extras": {
        "name": "Extras",
        "description": "Connect the wider operations that keep your B2B running smoothly."
      }
    },
    "features": {
      "storefront-widgets": {
        "title": "B2B storefront widgets",
        "description": "Add the B2B buying experience to your store.",
        "body": "SparkLayer adds its B2B ordering interfaces to your theme - product pages, collection cards, a cart and account area - each showing that customer their own pricing. The widgets only appear when a B2B customer logs in, so retail shoppers see your store unchanged.",
        "action": "Open setup"
      },
      "price-lists": {
        "title": "Price lists",
        "description": "Set the B2B pricing your customers see.",
        "body": "Give each customer group its own pricing - percentage discounts, fixed wholesale prices, or volume price breaks. Your retail storefront prices stay untouched.",
        "action": "Open price lists"
      },
      "assigned-pricing": {
        "title": "Assigned pricing",
        "description": "Create price lists and allocate them to your customers.",
        "body": "Give each customer group its own price list. Keep one general wholesale list for most trade customers, and assign tailored lists to specific groups or individual customers where they need different pricing.",
        "action": "Open price lists"
      },
      "order-rules": {
        "title": "Order rules",
        "description": "Set order requirements per customer group.",
        "body": "Set the order requirements each customer group must meet before checkout - minimum and maximum order values, or minimum and maximum quantities - applied automatically to everyone in the group.",
        "action": "Open customer groups"
      },
      "stock-display": {
        "title": "Stock display",
        "description": "Choose which customers can see stock levels.",
        "body": "Show or hide stock levels per customer group. Reveal live availability to the groups that need it and hide it from the rest - including on pre-order products where you'd rather not show stock.",
        "action": "Open customer groups"
      },
      "payment-methods": {
        "title": "Payment methods",
        "description": "Control how each customer group pays you.",
        "body": "Choose the payment methods available to each customer group - pay upfront by card, request or pay by invoice, pay on account with net terms, or request a quote to negotiate before ordering.",
        "action": "Open customer groups"
      },
      "b2b-catalogs": {
        "title": "B2B catalogs",
        "description": "Control which products your customers can see.",
        "body": "Control exactly which products each customer can see. Hide retail-only lines, surface trade-exclusive ranges, or build a tailored assortment per customer type, tag, or group - right down to individual variants.",
        "action": "View app"
      },
      "forms": {
        "title": "Forms",
        "description": "Wholesale registration and customer onboarding.",
        "body": "Onboard new trade customers with a branded application form. Collect the details you need - business type, VAT number, resale certificate - then review and approve each applicant before they get B2B access.",
        "action": "Open forms"
      },
      "sales-agents": {
        "title": "Sales agent ordering",
        "description": "Reps place orders on behalf of their customers.",
        "body": "Give reps their own login to place and manage orders on behalf of assigned customers, with the correct pricing applied automatically - no shared passwords, and it works from anywhere.",
        "action": "Set up sales agents"
      },
      "net-terms": {
        "title": "Net terms & credit allocations",
        "description": "Assign net terms or allocate credit allowances for trusted customers.",
        "body": "Let trusted customers buy now and pay on account. Offer terms like Net 30, set individual credit limits, and control who qualifies - so approved buyers check out without paying upfront.",
        "action": "Configure payments"
      },
      "product-ordering-rules": {
        "title": "Product ordering rules",
        "description": "Pack sizes, MOQs and price breaks.",
        "body": "Shape how customers order to match how you sell. Set pack sizes, minimum and maximum quantities, and quantity-based price breaks - for individual products, customer groups, or store-wide.",
        "action": "Configure product settings"
      },
      "advanced-discounts": {
        "title": "Advanced discounts",
        "description": "Order discounts, codes and customer offers.",
        "body": "Go beyond standard price lists with targeted trade offers - order level discounts, promotional codes, and customer group specific deals, complete with start dates, end dates, and usage limits.",
        "action": "Open discounts"
      },
      "b2b-shipping": {
        "title": "B2B shipping",
        "description": "Zones, rates and free-shipping thresholds.",
        "body": "Set shipping rules made for wholesale orders - rates by zone, weight, or order value, different pricing per customer group, and free-shipping thresholds that nudge buyers toward larger orders.",
        "action": "Open shipping settings"
      },
      "invoicing": {
        "title": "Invoicing",
        "description": "Send invoices and automate draft orders.",
        "body": "Automatically generate branded invoices for customers to view and download, and create draft orders in your store for orders you need to handle manually - giving account customers a clear record to pay against.",
        "action": "Configure invoicing"
      },
      "connect-accounting": {
        "title": "Connect Xero / QuickBooks",
        "description": "Sync invoices and payments to your accounts.",
        "body": "Sync invoices and payments straight into Xero or QuickBooks so your books stay reconciled automatically - no manual re-keying and no month end export scramble.",
        "action": "Configure integrations"
      },
      "quoting": {
        "title": "Quoting",
        "description": "Customers request quotes; you review and approve.",
        "body": "Let customers request a quote instead of buying outright. Review the request, adjust pricing or quantities, and approve - turning back-and-forth negotiation into a tracked on-store workflow that converts straight to an order.",
        "action": "Configure quoting"
      },
      "company-users": {
        "title": "Company users",
        "description": "Sub-accounts and shared purchasing permissions.",
        "body": "Let one business account have multiple buyers, each with their own login. Decide who can order freely and who can only add items that need the account owner's approval before they're placed - all sharing one company profile and order history.",
        "action": "Open customers"
      }
    }
  }
}
